import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AppService } from '../app.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-contentmain',
  templateUrl: './contentmain.component.html',
  styleUrls: ['./contentmain.component.scss']
})
export class ContentmainComponent implements OnInit {

  contId;
  contTitle: string;
  contData: any;
  subContDataCat: any;
  subContDataLength: number;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _appService: AppService,
    private sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService
  ) {
    this._router.routeReuseStrategy.shouldReuseRoute = function(){
      return false;
    }

    this._router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this._router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit() {
    this.spinner.show();
    const contId = this._route.snapshot.params.id;

    this._appService.getContentById(contId).subscribe(res => {
      this.contTitle = res['cont_title'];
      this.contData = this.sanitizer.bypassSecurityTrustHtml(res['cont_data']);
      this.spinner.hide();
    });

    this._appService.getSubContents(contId).subscribe(contRes => {
      console.log(contRes);
      this.subContDataCat = contRes;
      this.subContDataLength = contRes['length'];
      this.spinner.hide();
    });
  }

}
